/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bonuspunktprogramm.ts.
 */
import {BonuspunktprogrammStufe} from './bonuspunktprogramm-stufe';

/**
 * Zweck: Beschreibt class Bonuspunktprogramm und ihren Daten- oder Funktionsvertrag.
 */
export class Bonuspunktprogramm {
  BonuspunktprogrammUuid: string;
  Matchcode: string;
  Bezeichnung: string;
  WeitereProgrammeErlaubt: boolean;
  BonuspunktprogrammStufen: BonuspunktprogrammStufe[];

  // Für GUi
  level: number;
}
